import type { RiskAssessmentQuestionSectionProps } from "./RiskAssessmentForm.shared";
import { RiskAssessmentGenericSections } from "./RiskAssessmentGenericSections";

export function RiskAssessmentGenericForm(props: RiskAssessmentQuestionSectionProps) {
  return <RiskAssessmentGenericSections {...props} />;
}
